import {
  GET_LAYER_LOADING,
  GET_LAYER_FULFILLED,
  GET_LAYER_REJECTED
} from 'actions/project/layer.actions';

const initialState = {
  layers: [],
  layersParams: {},
  layersTooltips: {},
  loading: false,
  error: null,
};

const layersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LAYER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case GET_LAYER_FULFILLED:
      return {
        ...state,
        loading: false,
        layers: action.data.layer.layers,
        layersParams: action.data.layer.layersParams,
        layersTooltips: action.data.layer.layersTooltips,
        error: null,
      };
    case GET_LAYER_REJECTED:
      return {
        ...state,
        ...initialState,
        loading: false,
        error: action.data.error.message,
      };
    default:
      return state;
  }
};

export default layersReducer;
